<template>
    <div class="d-flex w-100 others-message" :class="{ grouped: shouldHideMessageInfo }" :id="`msg-id-${message.id}`">
        <div v-if="!message.isAutoGenerated" class="d-flex align-items-end w-90">
            <AvaInitials
                classes="ava-sm ava-initials-main mt-1"
                :initialsType="AvaInitialsType.Single"
                :user="getUser(getLoginIdByUserId(this.message.senderUserId))"
                :showStatus="true"
            />
            <div class="message-body">
                <div
                    class="d-flex message-info justify-content-between w-100"
                    v-if="!shouldHideMessageInfo || message.isEdited || message.isImportant"
                >
                    <span v-if="!shouldHideMessageInfo || message.isEdited">
                        <template v-if="!shouldHideMessageInfo">
                            <span class="me-2">
                                {{ message.senderDetails?.firstName }}
                                {{ message.senderDetails?.lastName || "" }}
                            </span>
                            <span class="me-2">
                                {{ formatMessageTime(message.createdOn) }}
                            </span>
                        </template>

                        <span v-if="message.isEdited && !message.isDeprecated" class="me-2"> Edited </span>
                    </span>
                    <span v-if="message.isImportant && !message.isDeprecated" class="fw-bold text-danger pe-3">
                        IMPORTANT
                    </span>
                </div>
                <div
                    v-if="message.isDeprecated"
                    class="d-flex align-items-center others-message-body highlight-body fst-italic"
                >
                    This message has been deleted.
                </div>
                <div v-else class="d-flex align-items-start">
                    <MessageHoverActions
                        :message-id="message.id"
                        position="right"
                        @hover-closed="closeEmojiPicker"
                        ref="hoverActions"
                    >
                        <template #message>
                            <div class="others-message-body highlight-body">
                                <!-- Reply of Message -->
                                <div
                                    class="card bg-form-section material-card reply-message-body my-1 cursor-pointer"
                                    v-if="message.replyToMessage"
                                    @click="handleReplyMsgNavigation"
                                >
                                    <div class="d-flex w-100">
                                        <span class="message-info reply-message-info">
                                            <span class="me-2">
                                                <span v-if="message.replyToMessage.senderDetails">
                                                    {{ message.replyToMessage.senderDetails.firstName }}
                                                    {{
                                                        message.replyToMessage.senderDetails?.lastName
                                                            ? message.replyToMessage.senderDetails?.lastName
                                                            : ""
                                                    }}
                                                </span>
                                            </span>
                                            <span class="me-2">
                                                {{ formatMessageTime(message.replyToMessage.createdOn) }}</span
                                            >
                                        </span>
                                    </div>
                                    <template v-if="message.replyToMessage.text">
                                        <span
                                            class="reply-message-text my-1"
                                            v-html="
                                                sanitizeMarkup(
                                                    markdownToHtml(formatReplyToMsgText(message.replyToMessage))
                                                )
                                            "
                                        ></span>
                                    </template>
                                    <span v-else-if="replyMsgProfiles">
                                        <span
                                            v-for="profile in replyMsgProfiles"
                                            :key="profile.id"
                                            class="d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
                                        >
                                            <i class="fas fa-user-circle fa-lg pe-1"> </i>
                                            <span> {{ profile.name }} </span>
                                        </span>
                                    </span>
                                </div>

                                <!-- Reply of Message Ends -->
                                <div
                                    class="message-content"
                                    @click="handleEventPropagation"
                                    v-html="sanitizeMarkup(markdownToHtml(formattedMessage))"
                                ></div>
                                <template v-if="sharedProfilesList?.length > 0">
                                    <p class="profile-box">
                                        <span
                                            v-for="profile in sharedProfilesList"
                                            :key="profile.id"
                                            contenteditable="false"
                                            class="d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2 cursor-pointer"
                                        >
                                            <i class="fas fa-user-circle fa-lg pe-1"></i>
                                            <span @click="redirectToProfile(profile)">
                                                {{ profile.name }}
                                            </span>
                                        </span>
                                    </p>
                                </template>
                                <template v-if="message.assetIds.length > 0">
                                    <div class="loader-parent" v-if="assetLoading">
                                        <div class="msg-loader"></div>
                                    </div>
                                    <ul v-if="fetchedAssets.length > 0 && !assetLoading" class="d-flex flex-wrap gap-1">
                                        <template v-for="(assetResponse, index) in fetchedAssets" :key="index">
                                            <template v-if="isImage(assetResponse.asset.mimeType)">
                                                <div class="position-relative">
                                                    <img
                                                        :class="`image my-2 ${
                                                            assetResponse.asset.showDownloadBtn ? 'image-blur' : ''
                                                        }`"
                                                        :src="assetResponse.asset.url"
                                                        :alt="assetResponse.asset.fileName"
                                                        @click="
                                                            assetResponse.asset.showDownloadBtn =
                                                                !assetResponse.asset.showDownloadBtn
                                                        "
                                                    />
                                                    <a
                                                        href="javascript:void(0);"
                                                        v-if="assetResponse.asset.showDownloadBtn"
                                                        class="img-download-btn"
                                                        @click="(e) => downloadAsset(assetResponse.asset, e)"
                                                    >
                                                        <i class="fas fa-download me-1"></i>
                                                        <span class="file-size">{{
                                                            formatFileSize(assetResponse.asset.fileSize)
                                                        }}</span>
                                                    </a>
                                                </div>
                                            </template>
                                            <span v-else>
                                                <div
                                                    class="m-1 py-2 px-2 file-render text-light d-flex flex-column justify-content-end position-relative"
                                                >
                                                    <a
                                                        class="file-download"
                                                        @click="(e) => downloadAsset(assetResponse.asset, e)"
                                                        :href="assetResponse.asset.url"
                                                        ><i class="fas fa-download me-1"></i>
                                                        <span class="file-size">{{
                                                            formatFileSize(assetResponse.asset.fileSize)
                                                        }}</span></a
                                                    >
                                                    <p class="fw-bold mb-0">
                                                        {{
                                                            truncateString(
                                                                assetResponse.asset.fileName.split(".")[0],
                                                                45
                                                            )
                                                        }}
                                                    </p>
                                                    <p class="mb-0 file-details">
                                                        <span class="pe-1">{{
                                                            assetResponse.asset.fileName.split(".").pop().toUpperCase()
                                                        }}</span>
                                                        <span class="file-size">{{
                                                            formatFileSize(assetResponse.asset.fileSize)
                                                        }}</span>
                                                    </p>
                                                </div>
                                            </span>
                                        </template>
                                    </ul>
                                </template>
                            </div>
                        </template>
                        <!-- Single container for hover actions -->
                        <template #actions>
                            <!-- Row 1: Quick reactions + EmojiPicker -->
                            <div class="hover-actions-card">
                                <div class="hover-reactions">
                                    <span
                                        v-for="emoji in defaultQuickReactions"
                                        :key="emoji"
                                        class="reactions-btn"
                                        @click="handleEmoji(emoji)"
                                    >
                                        {{ emoji }}
                                    </span>
                                    <div @click.stop>
                                        <EmojiPicker :isHover="true" ref="emojiPicker" @emoji-selected="handleEmoji" />
                                    </div>
                                    <!-- Divider -->
                                    <div class="hover-divider"></div>

                                    <!-- Reply -->
                                    <span
                                        class="hover-action-btn"
                                        @click="replyToMessage"
                                        v-tooltip="{ title: `Reply`, placement: 'top' }"
                                    >
                                        <img src="../../../../../assets/images/chat/reply.svg" />
                                    </span>
                                </div>
                            </div>
                        </template>
                    </MessageHoverActions>
                    <div v-if="message.isImportant" class="ms-2 text-danger">
                        <i class="fas fa-exclamation"></i>
                    </div>
                    <!-- </div> -->
                    <div v-if="showTaggedSign" class="ms-2 text-danger fw-bold">@</div>
                </div>
                <MessageReactions :message="message" />
            </div>
        </div>
        <div
            v-else-if="
                message.isAutoGenerated &&
                [
                    AutoGeneratedMessageEnum.ParticipantAdded,
                    AutoGeneratedMessageEnum.ParticipantLeft,
                    AutoGeneratedMessageEnum.GroupNameChange
                ].includes(message.autoMessageType)
            "
            class="message-auto-generated"
        >
            <span class="message-auto-generated--text"> {{ formatLocalDateWithMeridiem(message.createdOn) }} </span
            ><span class="message-auto-generated--text">{{ formattedMessage }}</span>
        </div>
        <div v-else-if="message.isAutoGenerated" class="message-auto-generated">
            <img :src="renderImage(message)" class="ms-4 ps-2" />
            <span class="message-auto-generated--text">
                {{ formatLocalDateWithMeridiem(message.createdOn) }}
            </span>
            <span class="message-auto-generated--text">{{ formattedMessage }}</span>
        </div>
    </div>
</template>

<script lang="ts" src="./OthersMessage.ts"></script>
<style src="./OthersMessage.scss"></style>
